import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { resetPassword } from '../actions';
import { getResetEmail } from 'reducers';

import Form from 'forms/Form';
import InputField from 'forms/InputField';
import Box from 'common/Box';

export const ResetPasswordForm = (props) => (
  <div className="ResetPasswordForm">
    <Box>
      <Form {...props} submit="Reset Password">
        <Field component={InputField} name="reset_code" label="Enter the reset code that was sent to you" />
        <Field component={InputField} name="new_password" label="Choose a new password" />
        <Field component={InputField} name="new_password_confirmation" label="Confirm password" />
      </Form>
    </Box>
  </div>
);

const validate = (values) => {
  const err = {}

  if (!values.reset_code) {
    err.reset_code = 'This field is required';
  }
  if (!values.new_password) {
    err.new_password = 'This field is required';
  }
  if (!values.new_password_confirmation) {
    err.new_password_confirmation = 'This field is required';
  }
  if (values.new_password !== values.new_password_confirmation) {
    err.new_password_confirmation = 'Password confirmation does not match';
  }

  return err;
}

const mapStateToProps = (state) => ({
  initialValues: {
    email: getResetEmail(state)
  }
});

export default connect(
  mapStateToProps,
  null
)(reduxForm({
  form: 'resetPassword',
  onSubmit: resetPassword,
  validate,
})(ResetPasswordForm));
